import { FaqEntryResp } from 'types/api/response/faq-entry-resp'
import { api } from '@marketplace-web/core-api/core-api-client-data'

export const getFaqEntryById = (id: string) => api.get<FaqEntryResp, unknown>(`/faq_entries/${id}`)
